import { navLinks, tickerItems } from "@/mocks/home";

export default function Masthead() {
  return (
    <header className="shell relative z-30">
      {/* 顶部厚运营条 */}
      <div className="border-b border-background-200 bg-primary-900 text-background-50">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-2 text-xs">
          <p className="flex items-center gap-2 whitespace-nowrap">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
            </span>
            51吃料 · 持续更新实时跟进中
          </p>
          <div className="hidden items-center gap-5 sm:flex">
            <a href="#briefing" className="whitespace-nowrap text-background-200 transition-colors hover:text-background-50">近 24h 速览</a>
            <span className="h-3 w-px bg-background-700" />
            <a href="#faq" className="whitespace-nowrap text-background-200 transition-colors hover:text-background-50">帮助与纠错</a>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div className="border-b border-background-200 bg-background-50">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-4 md:py-5">
          <a href="#top" className="group flex items-baseline gap-1">
            <span className="rounded bg-primary-600 px-1.5 py-0.5 text-sm font-black leading-none text-background-50">51</span>
            <span className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[1.7rem]">吃料</span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="whitespace-nowrap text-[15px] font-medium text-foreground-600 transition-colors hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2 md:flex">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                className="w-28 bg-transparent text-sm outline-none placeholder:text-foreground-400"
                placeholder="搜线索 / 关键词"
              />
            </div>
            <a
              href="#briefing"
              className="whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
            >
              立即追更
            </a>
            <button type="button" className="flex h-9 w-9 items-center justify-center rounded-md text-lg text-foreground-700 lg:hidden" aria-label="菜单">
              <i className="ri-menu-line" />
            </button>
          </div>
        </div>
      </div>

      {/* 实时跟进跑马灯 */}
      <div className="flex items-stretch border-b border-background-200 bg-background-100">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-accent-500 px-3 py-2 text-xs font-bold text-foreground-950 md:px-4">
          <i className="ri-flashlight-line" />
          <span className="whitespace-nowrap">实时跟进</span>
        </div>
        <div className="relative flex flex-1 items-center overflow-hidden">
          <div className="flex min-w-full shrink-0 animate-marquee items-center gap-10 px-4 whitespace-nowrap">
            {[...tickerItems, ...tickerItems].map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-[13px] text-foreground-600">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}